import { IonContent, IonPage, IonSearchbar } from '@ionic/react';
import OrdersCard, {
  OrdersCardSkeleton,
} from '../../../../components/Dashboard/Orders/OrdersCard';
import { IonicButton } from 'ionic-ui';
import PageTitle from '../../../../components/Dashboard/PageTitle';
import TabSwitch from '../../../../components/Dashboard/TabSwitch';
import { dashboardPageStyle } from '../../Layout';
import useStoreOrdersService from '../../../../services/orders/hooks/useStoreOrdersService';
import EmptyPage from '../../../../components/ui/EmptyPage';
import { OrderStatusType } from '../../../../types/order/orderType';

const dummyOrders = new Array(5).fill(0);

export default function Index() {
  const ordersTabs: {
    label: string;
    value: OrderStatusType | 'all';
  }[] = [
    { label: 'All', value: 'all' },
    { label: 'Paid', value: 'successful' },
    { label: 'Packed', value: 'marked_as_packed' },
    { label: 'Shipped', value: 'shipped' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Settled', value: 'settled' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Failed', value: 'failed' },
  ];

  const { ordersQuery, applyFilter, filters } = useStoreOrdersService();

  const isLoading = ordersQuery.isPending || ordersQuery.isFetching;
  const hasOrders = !!ordersQuery.data && ordersQuery.data.length > 0;
  return (
    <IonPage>
      <IonContent>
        <div className={dashboardPageStyle}>
          {/* PAGE HEADER */}
          <div className="space-y-2">
            <PageTitle>
              <span>Orders </span>
              {/* <span className="text-customs-bright-cyan">
                ({numberOfOrders})
              </span> */}
            </PageTitle>
            <p className="medium-emphasis-text">
              Stay on top of your bookings and orders
            </p>
          </div>

          {/* FILTER BAR */}
          <div className="w-full flex flex-wrap gap-4 justify-between items-center">
            <div className="max-lg:w-full">
              <TabSwitch
                activeTab={filters.status || ordersTabs[0].value}
                tabs={ordersTabs}
                className="max-lg:w-full"
                onChange={(selectedTab) => applyFilter('status', selectedTab)}
              />
            </div>

            <div className="flex max-lg:w-full items-stretch flex-wrap gap-2">
              <div className="flex-1 min-w-36">
                <IonSearchbar
                  placeholder="Search"
                  style={{
                    '--box-shadow': 'none',
                    '--background': 'transparent',
                  }}
                  showClearButton="never"
                  className="p-0 h-full bg-gray-50 rounded-md min-h-9 text-sm font-dm_sans border border-border font-light medium-emphasis"
                />
              </div>

              {/* <div className="flex-1 min-w-36">
                <IonicInput
                  type="select"
                  labelPlacement="start"
                  containerClass="!gap-2 items-center h-full !flex-row bg-gray-50"
                  innerContainerClass="max-h-full h-full !w-auto flex-1"
                  className="w-full medium-emphasis-text"
                  labelClass="!m-0"
                  options={[
                    {
                      label: 'Most Popular',
                      value: 'popular',
                    },
                  ]}
                />
              </div> */}

              <IonicButton
                size="lg"
                className="flex-1 min-w-fit button-with-icon"
                type="button"
                onClick={ordersQuery.refetch}
              >
                {ordersQuery.isRefetching && (
                  <span className="block w-4 h-4 border-2 border-t-transparent border-white/80 rounded-full animate-spin" />
                )}
                <span>Refresh Orders</span>
              </IonicButton>
            </div>
          </div>

          {/* ORDERS SECTION */}
          {ordersQuery.isError ? (
            <EmptyPage message="Something went wrong" className="h-[40vh]">
              <IonicButton
                onClick={ordersQuery.refetch}
                variant="ghost"
                className="high-emphasis-text w-fit mx-auto"
              >
                Try Again
              </IonicButton>
            </EmptyPage>
          ) : isLoading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {dummyOrders.map((_, idx) => (
                <OrdersCardSkeleton key={idx} />
              ))}
            </div>
          ) : hasOrders ? (
            <div className="grid grid-cols-1 md:grid-cols-2 w-full gap-4">
              {ordersQuery.data!.map((order, idx) => (
                <OrdersCard key={idx} {...order} />
              ))}
            </div>
          ) : (
            <EmptyPage message="You have no orders yet" className="h-[40vh]" />
          )}
        </div>
      </IonContent>
    </IonPage>
  );
}
